export enum EBannerType {
  RealtorRequestTrap,
  LocationSubscription,
}
